import { parseDataPoints } from '@tableau/metrics-engine';
import { IMetricDataInfo } from '../../ts/models/IMetricInfo';
import { IMetricDataPoints } from '../../ts/ServerApi/types/IMetricDataList';

import { MetricsDataAction, MetricsDataActionTypes } from '../actions';
import { Loadable } from '../models/Loadable';
import { notLoadedData } from '../selectors';
import { InitialMetricsDataState, LoadableDataPointsById, MetricsDataState } from '../state/MetricsDataState';

export const metricsDataStateReducer = (
  state: MetricsDataState = InitialMetricsDataState,
  action?: MetricsDataAction
): MetricsDataState => {
  switch (action?.type) {
    case MetricsDataActionTypes.REQUEST_START: {
      const stateToAdd: LoadableDataPointsById = {};
      const idsToLoad = notLoadedData(state, action.ids);
      idsToLoad.forEach((id) => {
        stateToAdd[id] = Loadable.loading({});
      });

      return { dataPointsById: { ...state.dataPointsById, ...stateToAdd } };
    }
    case MetricsDataActionTypes.REQUEST_SUCCEEDED: {
      const stateToAdd: LoadableDataPointsById = {};
      Object.entries(action.dataPointsById).forEach(([key, value]) => {
        stateToAdd[key] = Loadable.loaded(parseResponse(value));
      });

      return { dataPointsById: { ...state.dataPointsById, ...stateToAdd } };
    }
    case MetricsDataActionTypes.REQUEST_FAILED: {
      const stateToAdd: LoadableDataPointsById = {};
      Object.entries(action.failuresById).forEach(([key, value]) => {
        stateToAdd[key] = Loadable.failed(value.message, undefined);
      });

      return { dataPointsById: { ...state.dataPointsById, ...stateToAdd } };
    }
    case MetricsDataActionTypes.CLEAR: {
      return InitialMetricsDataState;
    }
    case undefined:
    default:
      return state;
  }
};

const parseResponse = (input: IMetricDataPoints): IMetricDataInfo => {
  return {
    dataPoints: parseDataPoints(input.points),
    schema: input.schema,
    dataRefreshedTimestamp: input.dataRefreshedTimestamp,
  };
};
